(() => {
  'use strict';
  const DESKTOP = window.matchMedia('(min-width: 769px)');
  if (window.__tpPriceClarityCleanup) window.__tpPriceClarityCleanup();

  let stopped = false;
  let frame = 0;
  const undo = [];

  const listen = (node, event, handler, options) => {
    node.addEventListener(event, handler, options);
    undo.push(() => node.removeEventListener(event, handler, options));
  };

  const text = (node, value) => {
    if (!node) return;
    if (node.textContent !== value) node.textContent = value;
  };

  const parseMoney = value => {
    const cleaned = String(value).replace(/[^\d,.-]/g, '');
    if (!cleaned) return NaN;
    if (cleaned.includes(',') && cleaned.includes('.')) {
      return parseFloat(cleaned.replace(/\./g, '').replace(',', '.'));
    }
    if (cleaned.includes(',')) return parseFloat(cleaned.replace(',', '.'));
    return parseFloat(cleaned);
  };

  const formatSaved = amount => {
    const cents = Math.round(amount * 100);
    if (window.theme?.Currency?.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat)
        .replace(/([,.])00(?=\D|$)/, '')
        .replace(/\s+/g, ' ')
        .trim();
    }
    const whole = Math.abs(cents % 100) < 1;
    const major = whole ? String(Math.round(amount)) : amount.toFixed(2).replace('.', ',');
    return major + ' zł';
  };

  const syncBlock = source => {
    const box = source.querySelector('[data-gg-tp-prices]');
    const current = source.querySelector('[data-product-price]');
    if (!box || !current || !current.textContent.trim()) return;

    const amount = box.querySelector('[data-gg-tp-amount]');
    const badge = box.querySelector('[data-gg-tp-badge]');
    const meta = box.querySelector('[data-gg-tp-meta]');
    const compare = box.querySelector('[data-gg-tp-compare]');
    const sep = box.querySelector('[data-gg-tp-sep]');
    const saved = box.querySelector('[data-gg-tp-saved]');
    const wrap = source.querySelector('[data-product-price-wrap]');
    const compareEl = source.querySelector('[data-compare-price]');

    const currentText = current.textContent.trim();
    const compareText = compareEl?.textContent.trim() || '';
    const sale = !!wrap && !wrap.classList.contains('hide') && !wrap.hidden && !!compareText;
    const currentAmount = parseMoney(currentText);
    const compareAmount = parseMoney(compareText);
    const hasSavings = sale && Number.isFinite(currentAmount) && Number.isFinite(compareAmount) && compareAmount > currentAmount;
    const percent = hasSavings ? Math.round((compareAmount - currentAmount) / compareAmount * 100) : 0;
    const savedAmount = hasSavings ? compareAmount - currentAmount : 0;
    const showBadge = hasSavings && percent > 0;

    text(amount, currentText);
    text(badge, showBadge ? '-' + percent + '% taniej' : '');
    if (badge && badge.hidden === !!showBadge) badge.hidden = !showBadge;
    text(compare, hasSavings ? compareText : '');
    text(saved, hasSavings ? 'Oszczędzasz ' + formatSaved(savedAmount) : '');
    if (meta && meta.hidden === !!hasSavings) meta.hidden = !hasSavings;
    if (sep && sep.hidden === !!hasSavings) sep.hidden = !hasSavings;
    if (saved && saved.hidden === !!hasSavings) saved.hidden = !hasSavings;
  };

  const render = () => {
    if (!DESKTOP.matches) return;
    document.querySelectorAll('.product-block--price').forEach(syncBlock);
  };

  const schedule = () => {
    if (stopped || !DESKTOP.matches || frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      if (stopped || !DESKTOP.matches) return;
      try { render(); } catch (error) {
        cleanup();
        console.warn('tp-price-clarity: stopped safely', error);
      }
    });
  };

  const observer = new MutationObserver(schedule);

  const cleanup = () => {
    if (stopped) return;
    stopped = true;
    observer.disconnect();
    cancelAnimationFrame(frame);
    undo.reverse().forEach(fn => fn());
    if (window.__tpPriceClarityCleanup === cleanup) delete window.__tpPriceClarityCleanup;
  };
  window.__tpPriceClarityCleanup = cleanup;

  const boot = () => {
    if (stopped) return;
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'hidden']
    });
    listen(document, 'variant:change', schedule);
    listen(document, 'change', schedule);
    listen(document, 'shopify:section:load', schedule);
    if (typeof DESKTOP.addEventListener === 'function') listen(DESKTOP, 'change', schedule);
    else if (typeof DESKTOP.addListener === 'function') {
      DESKTOP.addListener(schedule);
      undo.push(() => DESKTOP.removeListener(schedule));
    }
    schedule();
  };

  if (document.readyState === 'loading') listen(document, 'DOMContentLoaded', boot, {once: true});
  else boot();
})();
